import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { HttpService } from './http.service';
import { UtilsService } from './utils.service';

@Injectable()
export class RatesService {
  constructor(
    private http: HttpService,
    private utils: UtilsService,
  ) {}

  getRates(page: number = 1, page_size: number = 10) {
    let params = new HttpParams()
      .set('page', page.toString())
      .set('page_size', page_size.toString());

    return new Promise((resolve, reject) => {
      this.http.get(`consulted-rate`, params).subscribe(
        (resp: any) => {
          resolve(resp);
        },
        (error) => {
          reject(error);
        },
      );
    });
  }

  getRate(provider: number) {
    return new Promise((resolve, reject) => {
      this.http.get(`rate/${provider}`).subscribe(
        (resp: any) => {
          resolve(resp);
        },
        (error) => {
          reject(error);
        },
      );
    });
  }

  saveRate(body: any) {
    return this.http.post('consulted-rate', body);
  }

  getWeightedRate(body: any) {
    return this.http.post(`rates/weighted`, body).toPromise();
  }
}
